export const INVOICE = {
  ORDER: 'Order Amount',
  FINANCE: 'Finance Amount',
  INSTALLMENT: 'Installment Plan',
  ADMIN: 'Admin Fees',
};
